// @ts-check
import ReferralNotification from './ReferralNotification';

export default ReferralNotification;
